import React, { useEffect, useState } from "react";
import { useAuth, useNavigation } from "react-uicomp";
import {
  FaFacebookSquare,
  FaLinkedin,
  MdHome,
  MdLocalPhone,
  MdEmail,
  MdWatchLater,
} from "react-icons/all";
import moment from "moment";

// IMPORT ICONS
import Codniv_Logo from "../../../assets/icons/Codniv_logo.png";
import { useDispatch } from "react-redux";
import { api, APIS } from "../../../config/Config";
// import { getOfficeAction } from "../../../actions/Time.action";

const Footer = () => {
  const { language } = useAuth();
  const { navigation } = useNavigation();
  const { navigate, routes } = navigation;
  const dispatch = useDispatch();
  const [officeTime, setOfficeTime] = useState({
    closingTime: "16:15",
    openingTime: "09:15",
  });
  useEffect(() => {
    (async () => {
      const res = await api(`${APIS.office_time}`);
      const { success, data } = res.data;
      // console.log("office time", success, data);
      if (success === "true") {
        setOfficeTime(data?.data?.rows[0]?.description);
      }
    })();
  }, []);
  return (
    <div className="footer-container">
      <div className="footer">
        <div className="footer-links">
          <div className="footer-links-block first">
            <div className="footer-title">{language.key.nirc}</div>

            <div className="footer-desc">
              {language.key.homepage.introduction}
            </div>

            <div className="footer-icons">
              <div
                className="footer-icons-image"
                onClick={() =>
                  window.open("https://www.facebook.com/arspakh/")
                }>
                <FaFacebookSquare size={20} />
              </div>
              <div
                className="footer-icons-image"
                onClick={() =>
                  window.open(
                    "https://www.linkedin.com/in/arsp-pakhribas-167577a4/",
                  )
                }>
                <FaLinkedin size={20} />
              </div>
              {/* <div
                className="footer-icons-image"
                onClick={() => window.open("https://instagram.com/codniv")}>
                <AiFillInstagram size={20} />
              </div> */}
            </div>
          </div>

          {/* <div className="footer-links-block">
            <div>
              <div className="footer-links-block-title">Web Login</div>
              <div className="footer-links-block-links">
                <input placeholder="Email" />
                <br />
                <input placeholder="Passsword" />
                <br />
                <SecondaryButton title="Login" />
              </div>
            </div>
          </div> */}

          <div className="footer-links-block">
            <div>
              <div className="footer-links-block-title">
                {language.key.quickLinks}
              </div>
              <ul className="footer-links-block-links">
                <li
                  className="links-item"
                  onClick={() => navigate(routes["About Us"].path)}>
                  <span>About Us</span>
                  {/* <span>{language.key.publication}</span> */}
                </li>
                <li
                  className="links-item"
                  onClick={() => navigate(routes["Press Release"].path)}>
                  {/* <span>{language.key.newsletter}</span> */}
                  <span>Press Release</span>
                </li>
                <li
                  className="links-item"
                  onClick={() =>
                    navigate(routes["Current Research Projects"].path)
                  }>
                  <span>{language.key.currentResearch}</span>
                </li>
                <li
                  className="links-item"
                  onClick={() => navigate(routes["News & Notices"].path)}>
                  <span>{language.key.news}</span>
                </li>
                <li
                  className="links-item"
                  onClick={() => navigate(routes["Contact Us"].path)}>
                  <span>{language.key.contact}</span>
                </li>
              </ul>
            </div>
          </div>

          <div className="footer-links-block">
            <div>
              <div className="footer-links-block-title">
                {language.key.contact}
              </div>
              <ul className="footer-links-block-links">
                <li className="links-item">
                  <span className="links-item-icon">
                    <MdHome size={20} />
                  </span>
                  <span>
                    {language.key.contactpage.address1}
                    <br /> {language.key.contactpage.address2}
                    <br /> {language.key.contactpage.address4}
                  </span>
                </li>
                <li className="links-item">
                  <span className="links-item-icon">
                    <MdWatchLater size={20} />
                  </span>
                  <span>
                    {language.key.openinghours} :{" "}
                    {moment(officeTime.openingTime, "HHmm").format("LT")} to{" "}
                    {moment(officeTime.closingTime, "HHmm").format("LT")}
                  </span>
                </li>
                <li className="links-item">
                  <span className="links-item-icon">
                    <MdLocalPhone size={20} />
                  </span>
                  <span>{language.key.telephone}</span>
                </li>
                <li className="links-item">
                  <span className="links-item-icon">
                    <MdEmail size={20} />
                  </span>
                  <span>arspakh@gmail.com</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div className="footerinfo-container">
        <div className="footerinfo">
          <div className="footerinfo-left">
            COPYRIGHT {moment().format("YYYY")}. ALL RIGHTS RESERVED BY{" "}
            <span>ARSP</span>
          </div>
          <div
            className="footerinfo-right"
            onClick={() => window.open("https://codniv.com/")}>
            <span>Powered by</span>
            <img
              alt="Codniv Innovation Pvt. Ltd."
              title="Visit Codniv.com"
              src={Codniv_Logo}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
